/**
 * /ti/:code — inventory short-link install gate.
 * On first visit saves the hub URL, then redirects to /ti/hub.
 * Mirrors ProductionDashboardRedirect for the /pp/ portal.
 */
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { enterStaffPortal } from "@/lib/staffPortal";

export default function InventoryDashboardRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const hubUrl = "/ti/hub";
    enterStaffPortal("inventory", hubUrl);
    navigate(hubUrl, { replace: true });
  }, [code, navigate]);

  return null;
}
